export const aggFuncs = {
  sumQty: ({ values, rowNode: { rowGroupColumn } }) => {
    if (!rowGroupColumn || 'uom' !== rowGroupColumn.getColId()) {
      return null;
    }

    return values.reduce((acc: number, value: number) => acc + Number(value), 0);
  },
};
